import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CurrentSubscriptionWidget = ({ subscription, onManage, onCancel }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  const getStatusColor = () => {
    if (!subscription?.isActive) return 'text-error';
    const daysUntilRenewal = Math.ceil((new Date(subscription.renewalDate) - new Date()) / (1000 * 60 * 60 * 24));
    if (daysUntilRenewal <= 7) return 'text-warning';
    return 'text-success';
  };

  const getDaysUntilRenewal = () => {
    return Math.ceil((new Date(subscription.renewalDate) - new Date()) / (1000 * 60 * 60 * 24));
  };

  return (
    <div className="bg-gradient-to-br from-primary/10 to-secondary/10 rounded-xl p-4 md:p-6 border-2 border-primary/20">
      <div className="flex items-start justify-between mb-4 md:mb-6">
        <div className="flex items-center gap-3">
          <div className="p-2 md:p-3 bg-primary/10 rounded-lg">
            <Icon name="Crown" size={24} color="var(--color-primary)" />
          </div>
          <div>
            <h3 className="text-lg md:text-xl font-heading font-bold">Premium Subscription</h3>
            <p className="text-xs md:text-sm text-muted-foreground">Monthly Plan</p>
          </div>
        </div>
        <span className={`px-2 md:px-3 py-1 rounded-full text-xs font-medium ${
          subscription?.isActive ? 'bg-success/10 text-success' : 'bg-error/10 text-error'
        }`}>
          {subscription?.isActive ? 'Active' : 'Inactive'}
        </span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 mb-4 md:mb-6">
        <div className="p-3 md:p-4 bg-card rounded-lg">
          <p className="text-xs text-muted-foreground mb-1">Monthly Amount</p>
          <p className="text-xl md:text-2xl font-heading font-bold font-mono">₹{subscription?.amount?.toLocaleString('en-IN')}</p>
        </div>
        <div className="p-3 md:p-4 bg-card rounded-lg">
          <p className="text-xs text-muted-foreground mb-1">Next Billing Date</p>
          <p className={`text-base md:text-lg font-heading font-bold font-mono ${getStatusColor()}`}>
            {formatDate(subscription?.renewalDate)}
          </p>
          {subscription?.isActive && (
            <p className="text-xs text-muted-foreground mt-1">
              {getDaysUntilRenewal()} days remaining
            </p>
          )}
        </div>
      </div>
      <div className="space-y-2 md:space-y-3 mb-4 md:mb-6 p-3 md:p-4 bg-card rounded-lg">
        <div className="flex items-center justify-between text-xs md:text-sm">
          <span className="text-muted-foreground">Payment Method</span>
          <span className="font-medium font-mono">{subscription?.paymentMethod}</span>
        </div>
        <div className="flex items-center justify-between text-xs md:text-sm">
          <span className="text-muted-foreground">Auto-Renewal</span>
          <span className={`font-medium ${subscription?.autoRenew ? 'text-success' : 'text-error'}`}>
            {subscription?.autoRenew ? 'Enabled' : 'Disabled'}
          </span>
        </div>
        <div className="flex items-center justify-between text-xs md:text-sm">
          <span className="text-muted-foreground">Started On</span>
          <span className="font-medium font-mono">{formatDate(subscription?.startDate)}</span>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row gap-2 md:gap-3">
        <Button
          variant="outline"
          fullWidth
          iconName="Settings"
          iconPosition="left"
          onClick={onManage}
        >
          Manage Subscription
        </Button>
        <Button
          variant="destructive"
          fullWidth
          iconName="XCircle"
          iconPosition="left"
          onClick={onCancel}
        >
          Cancel Subscription
        </Button>
      </div>
      <div className="flex items-start gap-2 mt-4 p-3 bg-card rounded-lg">
        <Icon name="Info" size={16} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
        <p className="text-xs text-muted-foreground">
          You can cancel your subscription anytime. You'll continue to have access until the end of your current billing period.
        </p>
      </div>
    </div>
  );
};

export default CurrentSubscriptionWidget;